import React, { Component } from 'react';
import { connect } from 'react-redux';
import 'firebase/functions';
import { Button, Card, Avatar, Typography, Modal, Chip, Divider } from '@material-ui/core';
import Masonry from 'react-masonry-component';
import CreateTeam from './CreateTeam';
import { PageHeader } from '../../components';
import { COLORS } from '../../styles';
import './Teams.scss';

class Teams extends Component {
  state = { isCreateOpen: false }

  openCreateTeam() {
    this.setState({ isCreateOpen: true });
  }

  getUser(uid) {
    if (this.props.users.length) {
      let uids = this.props.users.map(user => user.uid);
      return this.props.users[uids.indexOf(uid)];
    }
  }

  renderUsers(members) {
    let userObjs = [];
    members.forEach(id => userObjs.push(this.getUser(id)));
    return (
      userObjs.map((user) => {
        return (
          <Avatar src={user.photoURL} key={user.uid}></Avatar>
        );
      })
    );
  }

  renderTeams() {
    let i = -1;
    return (
      this.props.teams.map((team) => {
        i++;
        let initials = "";
        let teamLeader = this.getUser(team.leader);
        if (!team.image && team.name.split(' ').length < 3) {
          team.name.split(' ').forEach((word) => initials += word[0]);
        } else { // else get first and last letter
          let splitTeamName = team.name.split(' ');
          initials += splitTeamName[0][0].toUpperCase();
          initials += splitTeamName[splitTeamName.length - 1][0].toUpperCase();
        }
        return (
          <Card
            key={this.props.teams.indexOf(team)}
            className="teamCard"
            style={{ backgroundColor: COLORS[i % COLORS.length] }}
          >

            <div className="teamTitleHolder">
              <Avatar className="teamAvatar">{initials}</Avatar>
              <Typography className="teamName">{team.name}</Typography>
            </div>

            <div className="leaderHolder">
              <Typography className="leader">Leader: </Typography>
              <Chip
                avatar={ <Avatar src={teamLeader.photoURL}/>}
                label={teamLeader.displayName}
                style={{ backgroundColor: 'white' }}
              />
            </div>

            <div style={{ width: '100%' }}>
              <Typography className="usersText">Users: </Typography>
              <Divider />
              <div className="userPictures">
                {this.renderUsers(team.members)}
              </div>
            </div>
          </Card>
        );
      })
    );
  }

  render() {
    return (
      <div>
        <PageHeader>Teams</PageHeader>
        <Button
          className="openModalButton"
          variant="contained"
          color="primary"
          onClick={this.openCreateTeam.bind(this)}
        >
          Create Team
        </Button>
        <Masonry
          className="gallery" // default ''
          disableImagesLoaded={false} // default false
          options={{ isFitWidth: true, gutter: 20 }}
          updateOnEachImageLoad={false} // default false and works only if disableImagesLoaded is false
        >
          {this.renderTeams()}
        </Masonry>

        <Modal className="createModal" open={this.state.isCreateOpen}>
          <CreateTeam closeModal={() => this.setState({ isCreateOpen: false })}/>
        </Modal>
      </div>
    );
  }

}

const mapStateToProps = ({ recognition }) => {
  const { users, teams } = recognition;
  return { teams, users };
};

export default connect(mapStateToProps)(Teams);



// WEBPACK FOOTER //
// ./src/screens/teams/Teams.js